import React from "react";

export function resolveLineName(line, byCode) {
  const it = byCode.get(line.internalCode);
  if (it) return { label: it.name, status: "live" };
  if (line.name) return { label: line.name, status: "deleted" };
  return { label: null, status: "missing" };
}

export function LineName({ line, byCode }) {
  const { label, status } = resolveLineName(line, byCode);
  if (status === "missing") return <span style={{ color: "var(--red)" }}>tidak tersedia</span>;
  if (status === "deleted") return <>{label} <span style={{ color: "var(--muted)" }}>(dihapus)</span></>;
  return <>{label}</>;
}
